// extracted by mini-css-extract-plugin
module.exports = {"GoBackBtn":"GoBackBtn_GoBackBtn__bxTu4","ShowBtn":"GoBackBtn_ShowBtn__22AJe","GoBackText":"GoBackBtn_GoBackText__iy6XP"};